import React, { useState } from "react";
import UpcomingCarsList from "../components/UpcomingCars/UpcomingCarsList";
import UpcomingCarsDetail from "../components/UpcomingCars/UpcomingCarsDetaill";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";

const UpcomingCars = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.upcomingCars}/`)?.[1];

  console.log(Vehicle_Id, `Vehicle_Id`)

  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);

  if (Vehicle_Id) {
    return (
      <UpcomingCarsDetail setDetailView={setDetailView} 
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
      />
    );
  }
  return (
    <UpcomingCarsList setDetailView={setDetailView}
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
      onCarClick={(car) => {
        setSelectedCar(car);
        setDetailView(true);
        navigate(`${routes.dashboardNavigation}${routes.upcomingCars}/${car?.Vehicle_Id}`);
      }}
    />
  );
};

export default UpcomingCars;
